import { Stack, AppBar, Toolbar, useTheme } from '@mui/material';

import { useAuthContext } from 'src/auth';
import { bgBlur } from 'src/theme/core/mixins/background';

import Logo from 'src/components/logo';
import { UserAvatar } from 'src/components/avatar';

import { HEADER } from './layoutConfig';

function Header() {
  const theme = useTheme();
  const { user } = useAuthContext();

  return (
    <AppBar
      position="relative"
      sx={{
        ...bgBlur({
          color: theme.palette.background.default,
        }),
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Toolbar
        sx={{
          justifyContent: 'space-between',
          height: {
            xs: HEADER.H_MOBILE,
            md: HEADER.H_MOBILE,
          },
          transition: theme.transitions.create(['height'], {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.shorter,
          }),
        }}
      >
        <Logo />
        <Stack
          flexGrow={1}
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
          spacing={3}
        >
          <UserAvatar
            sx={{
              border: `1px solid ${theme.palette.divider}`,
            }}
            label={`${user?.firstName?.[0]}${user?.lastName?.[0]}`}
          />
        </Stack>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
